var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1464 11.3536C9.95118 11.1583 9.95118 10.8417 10.1464 10.6464L14.2929 6.5L0.5 6.5C0.223858 6.5 0 6.27614 0 6C0 5.72386 0.223858 5.5 0.5 5.5L14.2929 5.5L10.1464 1.35355C9.95118 1.15829 9.95118 0.841709 10.1464 0.646447C10.3417 0.451184 10.6583 0.451184 10.8536 0.646447L15.8536 5.64645C15.9015 5.69439 15.9377 5.74964 15.9621 5.80861C15.9865 5.86756 16 5.93221 16 6C16 6.06779 15.9865 6.13244 15.9621 6.19139C15.9377 6.25036 15.9015 6.30561 15.8536 6.35355L10.8536 11.3536C10.6583 11.5488 10.3417 11.5488 10.1464 11.3536Z",
    fill: "#051C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.48d40590ec4afa8f8ee0d118fd55173a.svg";
export { ForwardRef as ReactComponent };